import { ILookup } from "../../common/interfaces/ILookup.interface";

export class TableListBuilderModel {
    public tableName: ILookup<number, string>;
    public columnName: ILookup<number, string>;
    public returnType: ILookup<number, string>;
    public columnType: ILookup<number, string>;
    public sortType: ILookup<number, string>;
    public conditions: Array<Condition>;
    
    constructor() {
        this.tableName = new ILookup<number, string>();
        this.columnName = new ILookup<number, string>();
        this.returnType = new ILookup<number, string>();
        this.columnType = new ILookup<number, string>();
        this.sortType = new ILookup<number, string>();
        this.conditions = new Array<Condition>();
    }
}

export class Condition {
    public columnName: ILookup<number, string>;
    public columnType: ILookup<number, string>;
    public operation: ILookup<number, string>;
    public operations: Array<ILookup<number, string>>
    public value: string;

    constructor() {
        this.columnName = new ILookup<number, string>();
        this.columnType = new ILookup<number, string>();
        this.operation = new ILookup<number, string>();
        this.operations = new Array<ILookup<number, string>>();
        this.value = '';
    }
}

export class PreviewTableData {
    public rowNumber: number;
    public rowValues: Array<string>;
}

export enum ConditionColumnType {
    Text = 1,
    Number = 2,
    Date = 3
}

export enum ColumnType {
    Text = 1,
    Number = 2,
    Date = 3
}

export enum ConditionOperationType {
    Equal = 1,  //'='
    GreaterThan = 2,  //'>'
    GreaterThanOrEqual = 3,  //'>='
    LessThan = 4,  //'<'
    LessThanOrEqual = 5,  //'<='
    BeginsWith = 6, //Begins with (like 'something%')
    EndsWith = 7, //Ends with (like '%something')
    Matches = 8, //Matches (like '%something%')
    MatchLower = 9,
    MatchLowerInclusive = 10,
    MatchUpper = 11,
    MatchUpperInclusive = 12
}

export enum ReturnType {
    Exact = 1,
    Min = 2,
    Max = 3,
    Count = 4,
    Average = 5,
    Sum = 6
}

export enum OrderType {
    None = 1,
    Asc = 2,
    Desc = 3
}